import { hapticFeedback } from "@telegram-apps/sdk-react";
import { useCallback } from "react";
import useSWR from "swr";
import localStorage from "~/tools/localStorage";

const useCurrentTokenOnly = () => {
    const cacheKey = "__uxuy_dex_cached_query_order_with_current_token_only__";

    const queryCachedIsCurrentTokenOnly = useCallback(() => {
        return localStorage.get(cacheKey).then((value) => value === "true");
    }, []);

    const {
        data: isCurrentTokenOnly,
        mutate,
        isLoading,
    } = useSWR("queryCachedIsCurrentTokenOnly", queryCachedIsCurrentTokenOnly);

    const toggleCurrentTokenOnly = useCallback(() => {
        if (isLoading) {
            return;
        }

        mutate(!isCurrentTokenOnly, { revalidate: false });
        hapticFeedback.impactOccurred("light");
        if (isCurrentTokenOnly) {
            localStorage.delete(cacheKey);
        } else {
            localStorage.set(cacheKey, "true");
        }
    }, [isCurrentTokenOnly]);

    return { isCurrentTokenOnly, toggleCurrentTokenOnly };
};

export default useCurrentTokenOnly;
